import { supabase, callFunction } from '../lib/supabase';

export const assessmentAPI = {
  // Submit eligibility assessment — calls edge function (public, works for guests too)
  submitAssessment: async (data) => {
    const { data: { user } } = await supabase.auth.getUser();
    const payload = { ...data, userId: user?.id ?? undefined };
    return callFunction('assess-eligibility', payload);
  },

  // Get current user's most recent assessment
  getMyAssessment: async () => {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error('Not authenticated');
    const { data, error } = await supabase
      .from('assessments')
      .select('*')
      .eq('user_id', user.id)
      .order('submitted_at', { ascending: false })
      .limit(1)
      .single();
    if (error && error.code !== 'PGRST116') throw error;
    return data;
  },

  // Get eligibility result for current user
  getEligibilityResult: async () => {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error('Not authenticated');
    const { data, error } = await supabase
      .from('assessments')
      .select('eligibility_status, eligibility_reason, recommended_program_id, recommended_program_name, bmi')
      .eq('user_id', user.id)
      .order('submitted_at', { ascending: false })
      .limit(1)
      .single();
    if (error && error.code !== 'PGRST116') throw error;
    return data;
  },

  // Get eligibility by assessment ID (public — for result pages, no auth needed)
  getEligibilityByAssessmentId: async (assessmentId) => {
    const { data, error } = await supabase
      .from('assessments')
      .select('id, eligibility_status, eligibility_reason, recommended_program_id, recommended_program_name, bmi')
      .eq('id', assessmentId)
      .single();
    if (error) throw error;
    return data;
  },

  // Check if current user has completed an assessment
  checkCompletion: async () => {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return { completed: false };
    const { count } = await supabase
      .from('assessments')
      .select('id', { count: 'exact', head: true })
      .eq('user_id', user.id);
    return { completed: (count ?? 0) > 0 };
  },
};

export default assessmentAPI;